import React, { useEffect, useRef, useState } from 'react';
import styles from './styles';
import PropTypes from 'prop-types';
import emailjs from '@emailjs/browser';
import debounce from 'utils/debounce';
import { IoMdClose } from 'react-icons/io';

const GetInTouch = ({ block }) => {
	if (!block) return '';
	const { primary } = block;
	const title1 = primary?.title1;
	const description = primary?.description;
	const emailTo = primary?.email_to;
	const image = primary?.image;

	const [firstName, setFirstName] = useState('');
	const [contactNumber, setContactNumber] = useState('');
	const [text, setText] = useState('');
	const [details, setDetails] = useState('');
	const [sending, setSending] = useState(false);

	const [enquire, setEnquire] = useState(false);
	const [showEnquire, setShowEnquire] = useState(false);

	const form = useRef();
	const modal = useRef();

	const sendEmail = (e) => {
		setSending(true);
		e.preventDefault();

		emailjs
			.sendForm(
				'service_z51h2hk',
				'template_b0xckqg',
				form.current,
				'EHLLCbLlIfGaD7hiA',
			)
			.then(
				(result) => {
					setFirstName('');
					setContactNumber('');
					setText('');
					setDetails('');
					setSending(false);
					alert('Successfully sent email!');
				},
				(error) => {
					console.log(error.text);
					setSending(false);
				},
			);
	};

	const characterLimit = 2000;

	const handleChange = (event) => {
		const newText = event.target.value;
		if (newText.length <= characterLimit) {
			setText(newText);
		}
	};

	const handleResize = () => {
		window.innerWidth < 768 ? setEnquire(true) : setEnquire(false);
	};

	useEffect(() => {
		handleResize();
		window.addEventListener('resize', debounce(handleResize, 1000));

		return () => {
			window.removeEventListener('resize', () => {});
		};
	}, []);

	const handleSlideOut = () => {
		modal.current.classList.remove('slide-back');
		modal.current.classList.add('slide-out');
		setShowEnquire(!showEnquire);
	};

	const handleSlideBack = () => {
		modal.current.classList.add('slide-back');
		modal.current.classList.remove('slide-out');
		setShowEnquire(!showEnquire);
	};

	const style = {
		position: 'absolute',
		top: '1rem',
		right: '1rem',
		fontSize: '2rem',
		cursor: 'pointer',
	};

	return (
		<>
			<div className='main-container wrapper'>
				<div className={`first_col`} ref={modal}>
					{showEnquire && <IoMdClose style={style} onClick={handleSlideBack} />}
					<div className='header-container'>
						<div className='header'>
							<h3 className='title'>{title1}</h3>
						</div>
						<p className='description'>{description}</p>
					</div>

					<div className='input-section-desktop'>
						<form ref={form} onSubmit={sendEmail}>
							<input
								className='input'
								type='text'
								hidden
								name='details'
								value={details}
							/>
							<input
								className='input'
								type='text'
								hidden
								name='email_to'
								value={emailTo}
							/>
							<input
								className='input'
								type='text'
								hidden
								name='region'
								value={'SG'}
							/>

							<div className='input-row'>
								<div className='input-container'>
									<div className='label-container'>
										<label className='label'>Name</label>
										<span className='required'>*</span>
									</div>
									<input
										required
										className='input'
										type='text'
										name='first_name'
										placeholder='Name'
										value={firstName}
										onChange={(e) => setFirstName(e.target.value)}
									/>
								</div>

								<div className='input-container'>
									<div className='label-container'>
										<label className='label'>Contact Number/Email</label>
										<span className='required'>*</span>
									</div>
									<input
										required
										className='input'
										type='text'
										name='contact_number'
										placeholder='Contact Number/Email'
										value={contactNumber}
										onChange={(e) => {
											setContactNumber(e.target.value),
												setDetails(`<b>Contact Number/Email: </b>${e.target.value}`);
										}}
									/>
								</div>
							</div>

							<div className='label-container'>
								<label required className='label'>
									Tell us your dream build design:{' '}
								</label>
								<span className='required'>*</span>
							</div>
							<textarea
								required
								className='textarea'
								type='textarea'
								name='message'
								placeholder='What do you have in mind for your dream build?'
								value={text}
								onChange={handleChange}
								rows={4}
								cols={50}
							/>
							<div className='counter-container'>
								<p className='counter'>
									{text.length} / {characterLimit}
								</p>
							</div>

							<div className='submit-container'>
								<button className='submit' type='submit'>
									{sending ? (
										<>
											{`Sending`}
											<span className='loader' />
										</>
									) : (
										'Submit'
									)}
								</button>
							</div>
						</form>
					</div>
					{enquire && (
						<div className='floater'>
							<EnquireNow handleSlideOut={handleSlideOut} />
						</div>
					)}
				</div>
				<div className='second_col'>
					<img draggable="false"  src={image?.url} alt='get_in_touch' />
				</div>
			</div>
			<style jsx>{styles}</style>
		</>
	);
};
GetInTouch.propTypes = {
	block: PropTypes.shape({
		primary: PropTypes.shape({
			title1: PropTypes.string,
			description: PropTypes.string,
		}),
	}),
};

GetInTouch.defaultProps = {
	block: null,
};

export default GetInTouch;

export const EnquireNow = ({ handleSlideOut }) => {
	return (
		<div id='enquire' onClick={handleSlideOut}>
			<img
				src='/icons/byteex_mobile_enquirenow.svg'
				alt='enquire_icon'
				draggable={false}
				style={{ transform: 'rotate(-90deg)' }}
			/>
			<span>ENQUIRE NOW</span>

			<style jsx>
				{`
					#enquire {
						background-color: #950810;
						color: #fff;
						border: none;
						padding: 1rem;
						border-radius: 1rem 1rem 0 0;
						width: max-content;
						display: flex;
						gap: 1rem;
						transform: translateX(-50%) rotate(90deg) translateY(-50%);
						cursor: pointer;
						animation: slide-from-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
							both;
					}
					@keyframes slide-from-left {
						0% {
							transform: translateX(-100%) rotate(90deg) translateY(-50%);
						}
						100% {
							transform: translateX(-50%) rotate(90deg) translateY(-50%);
						}
					}
					#enquire_icon {
						transform: rotate(-90deg);
						margin-right: 1rem;
						border: 1px solid blue;
					}
				`}
			</style>
		</div>
	);
};
